import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
    LayoutSingleColumn,
    LayoutWrapperTopbar,
    LayoutWrapperMain,
    LayoutWrapperFooter,
    Footer,
    ExternalLink,
} from '../../components';

import css from './SitemapPage.module.css';

const SitemapPage = () => {
    const { siteTwitterHandle, siteFacebookPage } = config;
    const siteTwitterPage = twitterPageURL(siteTwitterHandle);

    const urls = [
        "https://www.lenddit.com/",
        "https://www.lenddit.com/how-it-works",
        "https://www.lenddit.com/s",
        "https://www.lenddit.com/about",
        "https://www.lenddit.com/equipment-rental-agreement",
        "https://www.lenddit.com/cancellation-policy",
        "https://www.lenddit.com/contact",
        "https://www.lenddit.com/terms-of-service",
        "https://www.lenddit.com/privacy-policy",
        "https://www.lenddit.com/blog",
        "https://www.lenddit.com/sweepstakes",
        "https://www.lenddit.com/giveaway-winners"
    ];

    console.log(urls); // This will print the array to the console

    return (
        <StaticPage
            title="Sitemap"
            schema={{
                '@context': 'http://schema.org',
                '@type': 'SitemapPage',
                description: 'Sitemap',
                name: 'Sitemap',
            }}
        >
            <LayoutSingleColumn>
                <LayoutWrapperTopbar>
                    <TopbarContainer />
                </LayoutWrapperTopbar>

                <LayoutWrapperMain className={css.staticPageWrapper}>
                    <div>
                        <h1>Lenddit's Sitemap</h1>
                        <ul>
                            {urls.map(url => (
                                <li key={url}>
                                    <a href={url}>{url}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </LayoutWrapperMain>

                <LayoutWrapperFooter>
                    <Footer />
                </LayoutWrapperFooter>
            </LayoutSingleColumn>
        </StaticPage >
    );
};

export default SitemapPage;
